import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const services = [
    {
        title: "Tranformación cultural",
        description: "Te acompaño a generar una gestión del cambio oportuno y efectivo que asegure una transición segura y exitosa a la empresa profesionalizada. Transforme la forma de trabajar de su empresa, sacando el máximo provecho a los retos de la era digital.",
         icon: <LoopOutlinedIcon/>
    },
    {
        title: "Medición de Clima Laboral",
        description: "Medir el clima de tu empresa con la finalidad de mostrarte los factores subyacentes que están determinando el Clima Laboral de tu empresa, y recomendaciones para mejorarlo.",
        icon: <ShowChartOutlinedIcon />,
    },
    {
        title: "Taller de Liderazgo",
        description: "Formación para tus líderes, con la finalidad de desarrollar habilidades de liderazgo para alcanzar los resultados que aún no han conseguido. Formación orientada a la resolución de problemas, el manejo de conflictos y la mejora del desempeño.",
        icon: <GroupsOutlinedIcon/>,
    },
    {
        title: "Coaching Ejecutivo",
        description: "Entrenamiento para los líderes de tu empresa para que logren distinguir sus fortalezas y debilidades, y trazar un plan de desarrollo de aquellas competencias que son requeridas por su rol, y su equipo.",
        icon: <AdsClickOutlinedIcon/>,
    },
    {
        title: "Reclutamiento y Selección de Personal",
        description: "Brindo servicios de búsqueda y selección de personal para puestos gerenciales, mandos medios y puestos operativos. Nos adaptamos a las necesidades y a los tiempos de las empresas, ofreciendo un servicio de calidad y a la medida de cada cliente.",
        icon: <GroupAddOutlinedIcon/>,
    },
    {
        title: "Servicios Integrales para áreas de Recursos Humanos",
        description: "Incluye asesoría en cumplimiento laboral y optimización de procesos de recursos humanos.",
        subitems: [{
            title: "Análisis de organigrama y descripción de puestos de trabajo",
            description: "Un correcto análisis y descripción del puesto de trabajo brinda la información vital que será necesaria posteriormente en múltiples ocasiones, como ser una la de decisiones, el establecimiento de políticas de recursos humanos o a la hora de llevar a cabo un proceso de selección de personal.<br> Adicionalmente facilita la delimitación de responsabilidades en cada puesto de trabajo y ayuda a la existencia de una estructura jerárquica mas organizada en la empresa.",
        },
        {
            title: "Evaluación de desempeño",
            description: "Desarrollo de la herramienta de evaluacion de desempeño, entrenamiento de los evaluadores, e implementacion de la herramienta de gestión en todo la compañia.<br> La información que se logra con esta técnica es utilizada como complemento al momento de tomar las decisiones sobre promociones internas, capacitación, compensaciones, etc.",
        }],
        icon: <SettingsOutlinedIcon/>,
    },
]

export default services;